<template>
  <p class="fz-18" style="line-height:1.666">{{text}}</p>
</template>

<script>
export default {
  name: "textElement",
  props: ['text']
}
</script>

<style scoped>

</style>